import { createAction } from "@reduxjs/toolkit";

const UPDATE_CHARITY_ALLOCATION = "UPDATE_CHARITY_ALLOCATION";

export const updateCharityAllocation = createAction<number, string>(
  UPDATE_CHARITY_ALLOCATION
);
